module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/_add-to-unscopables.js
// module id = 495
// module chunks = 115